import React, {Component} from "react";
import NavbarComponent from "../components/NavbarComponent";
import EmployeesTable from "../components/tables/EmployeesTable";

class EmployeesPage extends Component {

    render() {
        return(
            <div>
                <NavbarComponent initValue={"/employees"}/>
                <EmployeesTable/>
            </div>
        );
    }
}

export default EmployeesPage;